import { booleanAttribute, Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { ApiTypes } from '../..';
import { EventTrackingService } from '../services/tracking.service';
import { TrackingElementType, TrackingEvent } from '../utilities/tracking';

@Directive({
    standalone: true,

    selector: '[tracking]',
})
export class TrackingDirective {
    trackingService = inject(EventTrackingService);
    element = inject(ElementRef);

    trackingEnabled = input(true, { transform: booleanAttribute });

    trackingEvent = input<TrackingEvent>('element_click');
    trackingElType = input.required<TrackingElementType>();
    trackingElLabel = input<string>();
    trackingElTarget = input<string>();
    trackingVehicle = input<ApiTypes.VehicleDetail>();

    @HostListener('click')
    onClick() {
        if (!this.trackingEnabled) {
            return;
        }

        this.trackingService.trackButton({
            elType: this.trackingElType(),
            event: this.trackingEvent(),
            elLabel: this.trackingElLabel(),
            elTarget: this.trackingElTarget(),
            vehicle: this.trackingVehicle(),
        });
    }
}
